/* Analizador de XMLTV (puede pesar decenas de MB). No usa DOMParser (no existe en los workers): extrae con expresiones
   regulares solo lo necesario: canal, inicio, fin, título y descripción. Lo usan el worker (epg-worker.js) y, si el
   dispositivo no deja crear workers (la app de Android carga desde file://), el propio hilo principal (epg.js). */

function decode(text) {
    if (!text || text.indexOf('&') === -1) return text || '';
    return text
        .replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, '$1')
        .replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'").replace(/&#39;/g, "'")
        .replace(/&#(\d+);/g, function (m, c) { return String.fromCharCode(parseInt(c, 10)); })
        .replace(/&#x([0-9a-f]+);/gi, function (m, c) { return String.fromCharCode(parseInt(c, 16)); })
        .replace(/&amp;/g, '&');
}

function parseTime(str) {
    // 20240131203000 +0100
    var m = /^(\d{4})(\d{2})(\d{2})(\d{2})?(\d{2})?(\d{2})?\s*([+-])?(\d{2})?(\d{2})?/.exec(str || '');
    if (!m) return 0;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
    if (m[7] && m[8]) {
        var offset = (+m[8] * 60 + +(m[9] || 0)) * 60000;
        utc -= m[7] === '+' ? offset : -offset;
    }
    return utc;
}

function stripTags(s) {
    // Un título en CDATA (<![CDATA[Título]]>) no es una etiqueta que quitar: se abre antes.
    return s.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, '$1').replace(/<[^>]+>/g, '');
}

function attr(tag, name) {
    var re = new RegExp('\\s' + name + '="([^"]*)"');
    var m = re.exec(tag);
    return m ? m[1] : '';
}


/**
 * Analizador por trozos: `feed(texto)` acepta el XMLTV entero o partido (cada trozo debe acabar en `</programme>` o ser
 * el último); `result()` devuelve { channels, total, channelCount } con los programas ordenados por inicio.
 */
export function createXmltvParser({ now = Date.now() } = {}) {
    var channels = {};
    var total = 0;
    var minTime = now - 2 * 86400000; // Guardar 2 días hacia atrás (catch-up) y todo el futuro.
    var titleRe = /<title[^>]*>([\s\S]*?)<\/title>/;
    var descRe = /<desc[^>]*>([\s\S]*?)<\/desc>/;
    return {
        feed: function (text, onProgress) {
            var re = /<programme\b([^>]*)>([\s\S]*?)<\/programme>/g;
            var m;
            var last = Date.now();
            while ((m = re.exec(text))) {
                var head = m[1];
                var start = parseTime(attr(head, 'start'));
                var stop = parseTime(attr(head, 'stop'));
                if (!start || !stop || stop < minTime) continue;
                var channel = attr(head, 'channel').trim().toLowerCase();
                if (!channel) continue;
                var body = m[2];
                var t = titleRe.exec(body);
                var d = descRe.exec(body);
                var list = channels[channel] || (channels[channel] = []);
                list.push([start, stop, decode(stripTags(t ? t[1] : '')).trim(), decode(stripTags(d ? d[1] : '')).trim()]);
                total++;
                if (onProgress && Date.now() - last > 400) {
                    last = Date.now();
                    onProgress(re.lastIndex, text.length);
                }
            }
        },
        result: function () {
            // Ordenar por inicio; algunos proveedores mezclan días.
            Object.keys(channels).forEach(function (id) {
                channels[id].sort(function (a, b) { return a[0] - b[0]; });
            });
            return { channels: channels, total: total, channelCount: Object.keys(channels).length };
        }
    };
}
